import React from "react";
import CreateFormOptions from "./CreateFormOptions";

const CreateFormInput = ({
  index,
  title,
  type,
  checkboxOptions,
  radioOptions,
  setQuestionInfo,
  deleteQuestion,
  updateOption,
  addOption,
}) => {
  const questionTypes = {
    text: "Text",
    paragraph: "Paragraph",
    number: "Number",
    checkbox: "Checkbox",
    radioButton: "Multiple Choice",
    attachment: "File Upload",
  };

  return (
    <div className="form-row my-4">
      <div className="col-12 col-md-8 mb-2">
        <input
          type="text"
          className="form-control"
          placeholder="Enter your question"
          value={title}
          onChange={(event) =>
            setQuestionInfo(index, "title", event.target.value)
          }
        ></input>
      </div>
      <div className="col-11 col-md-3">
        <select
          className="form-control"
          onChange={(event) =>
            setQuestionInfo(index, "type", event.target.value)
          }
        >
          {Object.keys(questionTypes).map((type) => (
            <option key={type} value={type}>
              {questionTypes[type]}
            </option>
          ))}
        </select>
      </div>
      <div
        className="col-1 col-md-1 my-auto"
        style={{ cursor: "pointer" }}
        onClick={() => deleteQuestion(index)}
      >
        &#10005;
      </div>

      {type === "checkbox" ? (
        <CreateFormOptions
          index={index}
          type="checkboxOptions"
          options={checkboxOptions}
          updateOption={updateOption}
          addOption={addOption}
        />
      ) : null}

      {type === "radioButton" ? (
        <CreateFormOptions
          index={index}
          type="radioOptions"
          options={radioOptions}
          updateOption={updateOption}
          addOption={addOption}
        />
      ) : null}
    </div>
  );
};

export default CreateFormInput;
